import { useEffect } from 'react';
import { Modal } from 'antd';
import { useBlocker } from 'react-router-dom';

export function useConfirmExit(isDirty: boolean) {
    const blocker = useBlocker(isDirty);

    useEffect(() => {
        if (blocker.state === 'blocked') {
            Modal.confirm({
                title: 'Sair sem salvar?',
                content:
                    'Existem alterações que não foram salvas. Deseja sair?',
                okText: 'Sair',
                cancelText: 'Voltar',
                width: 500,
                onOk() {
                    blocker.proceed();
                },
                onCancel() {
                    blocker.reset();
                },
            });
        }
    }, [blocker]);
}
